import { Autoplay, Keyboard, Mousewheel, Navigation } from 'swiper/modules'
import Swiper from 'swiper'

class CollectionSlider extends HTMLElement {
  constructor() {
    super()

    const collectionSliderElement = this
    const swiperHolder = collectionSliderElement.querySelector('.swiper')
    const enableLoop = collectionSliderElement.getAttribute('data-loop')
    const enableAutoplay = collectionSliderElement.getAttribute('data-autoplay')
    const autoplaySpeed = collectionSliderElement.getAttribute('data-autoplay-speed')
    const enableKeyboard = collectionSliderElement.getAttribute('data-keyboard')
    const swiperButtonNext = collectionSliderElement.querySelector('.swiper-button-next')
    const swiperButtonPrevious = collectionSliderElement.querySelector('.swiper-button-previous')
    const mobileBreakpoint = 320
    const desktopBreakpoint = 640
    const swiperConfig = {
      modules: [Mousewheel, Navigation],
      mousewheel: {
        forceToAxis: true,
      },
      direction: 'horizontal',
      navigation: {
        enabled: true,
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrevious,
      },
      threshold: 10,
      edgeSwipeDetection: true,
      breakpoints: {
        // when window width is >= 320px
        [mobileBreakpoint]: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        // when window width is >= 480px
        [desktopBreakpoint]: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    }

    if (enableAutoplay && enableAutoplay === 'true') {
      swiperConfig.modules = swiperConfig.modules ? [...swiperConfig.modules, Autoplay] : [Autoplay]
    }

    if (enableLoop && enableLoop === 'true') {
      swiperConfig.loop = true
    }

    if (autoplaySpeed && autoplaySpeed > 0) {
      swiperConfig.autoplay = {
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        delay: autoplaySpeed,
      }
    }

    if (enableKeyboard && enableKeyboard === 'true') {
      swiperConfig.modules = swiperConfig.modules ? [...swiperConfig.modules, Keyboard] : [Keyboard]
      swiperConfig.keyboard = {
        enabled: true,
      }
    }

    new Swiper(swiperHolder, swiperConfig)

    window.addEventListener('shopify:section:load', () => new Swiper(swiperHolder, swiperConfig))
  }
}

// Check if element is defined, if not define it.
// eslint-disable-next-line no-undefined
if (customElements.get('collection-slider') === undefined) {
  customElements.define('collection-slider', CollectionSlider)
}